var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKubernetesStatefullset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Kubernetes/Statefullset") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Kubernetes/Statefullset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Compute_64-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kubernetes-icon-color",
    mask: "url(#mask-2)",
    fill: "#326CE5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0336, 3.6398)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5498444,6.04629898 C25.4188509,5.50237441 25.049266,5.04549814 24.5428336,4.80144451 L14.8053589,0.181776273 C14.2942283,-0.0605920909 13.7002738,-0.0605920909 13.1891433,0.181776273 L3.45360163,4.80391419 C2.94704552,5.04781216 2.57733421,5.50466915 2.44631474,6.04863145 L0.0445672389,16.4312912 C-0.0146688153,16.6937301 -0.0148574099,16.9659284 0.0440149226,17.2284481 C0.0613528269,17.3084213 0.0840013192,17.3871659 0.11181175,17.4641651 C0.158813883,17.5955641 0.221045895,17.7210814 0.297251954,17.8381839 C0.330252854,17.8882635 0.365048782,17.936971 0.402882449,17.9841693 L7.14169383,26.3094508 C7.17110467,26.3456728 7.20355326,26.378739 7.23572568,26.4123541 C7.34146204,26.5242414 7.46085958,26.6225559 7.59114123,26.7050108 C7.75591645,26.8080603 7.93548813,26.8856423 8.12371224,26.9351024 C8.27806165,26.9771522 8.43728138,26.9989697 8.59732348,27 L8.7021255,27 L19.4038065,26.9975303 C19.4688634,26.9972448 19.5338566,26.9934432 19.598498,26.9861424 C19.6912241,26.9757251 19.7830298,26.9583884 19.8731372,26.9342791 C19.9377202,26.9173814 20.0013695,26.897139 20.0638245,26.8736349 C20.1125664,26.8551123 20.1611702,26.8365897 20.2081171,26.8142254 C20.2784254,26.7807749 20.346624,26.7431115 20.4123361,26.7014435 C20.5818949,26.5955038 20.7328751,26.462721 20.859298,26.3083532 L21.0647597,26.0545253 L27.5957621,17.9814252 C27.7209393,17.825451 27.8192903,17.6499766 27.8868328,17.462107 C27.9150365,17.3848484 27.9380994,17.3058314 27.9558723,17.2255668 C28.014895,16.9630635 28.0147064,16.6908322 27.95532,16.4284099 L25.5498444,6.04629898 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(9, 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.448324,0 L17,0 L17,8.04523348 L5.448324,8.04523348 L5.448324,0 Z",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeWidth: 0.915,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "2.745,2.745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#326CE5",
    points: "2.72428691 10.5224 14.2759629 10.5224 14.2759629 2.47716652 2.72428691 2.47716652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72428691,10.5224 L14.2759629,10.5224 L14.2759629,2.47716652 L2.72428691,2.47716652 L2.72428691,10.5224 Z",
    id: "Stroke-4",
    stroke: "#FFFFFF",
    strokeWidth: 0.915,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "2.745,2.745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    points: "0 13 11.551676 13 11.551676 4.95476652 0 4.95476652"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0, 4.9547)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-6",
    stroke: "#FFFFFF",
    strokeWidth: 0.915,
    strokeLinejoin: "round",
    points: "0 0 11.551676 0 11.551676 8.04523348 0 8.04523348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.943882349,2.23689939 L0.943882349,2.23689939 C0.943882349,1.483278 3.1073234,0.872082998 5.77540081,0.872082998 C8.44410278,0.872082998 10.6069193,1.483278 10.6069193,2.23689939 C10.6069193,2.99052079 8.44410278,3.60171579 5.77540081,3.60171579 C3.1073234,3.60171579 0.943882349,2.99052079 0.943882349,2.23689939",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6072316,2.23689939 L10.6072316,2.23689939 C10.6072316,2.99052079 8.4437905,3.60171579 5.77571309,3.60171579 C3.10701112,3.60171579 0.944194624,2.99052079 0.944194624,2.23689939 C0.944194624,1.483278 3.10701112,0.872082998 5.77571309,0.872082998 C8.4437905,0.872082998 10.6072316,1.483278 10.6072316,2.23689939 L10.6072316,5.9288392 C10.6072316,6.68246059 8.4437905,7.29365559 5.77571309,7.29365559 C3.10701112,7.29365559 0.944194624,6.68246059 0.944194624,5.9288392 L0.944194624,2.23689939",
    id: "Stroke-12",
    stroke: "#326CE5",
    strokeWidth: 0.915,
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKubernetesStatefullset);
export default __webpack_public_path__ + "static/media/KubernetesStatefullset.232194b414fd58e52e6baf8e77894eb2.svg";
export { ForwardRef as ReactComponent };